import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showInviteesForEvent as showInviteesForEventAction } from '../../store/EventStore';
import Menu from '../Menu';
import './EventOverview.css';
import Event from './Event';

const EventOverview = () => {
    const dispatch = useDispatch();
    const events = useSelector((state) => state.eventState.events); 
    const showInviteesForEvent = useSelector((state) => state.eventState.showInviteesForEvent); 
    
    const handleShowInvitees = (showInvitees, eventId) => {
        dispatch(showInviteesForEventAction({ show: showInvitees, eventId }));
    };

    const eventComponents = events.map((e) => {
        const showInvitees = showInviteesForEvent === e.id;
        return (
            <Event
                key={e.id}
                event={e}
                showInvitees={showInvitees}
                onClick={() => handleShowInvitees(!showInvitees, e.id)}
            />
        );
    });

    return (
        <div className="App">
            <Menu />
            <div className="event-overview">
                <div className="events">{eventComponents}</div>
            </div>
        </div>
    );
};

export default EventOverview;